



































import { Component, Vue, Ref } from 'vue-property-decorator';
import AuthSecurityCode from '@/components/Auth/AuthSecurityCode.vue';
import AuthErrorAlert from '@/components/Auth/AuthErrorAlert.vue';
import AuthResendBtn from '@/components/Auth/AuthResendBtn.vue';
import { ValidationObserver } from 'vee-validate';
import { mapState } from 'vuex';

@Component({
  components: {
    AuthSecurityCode,
    AuthErrorAlert,
    AuthResendBtn,
    ValidationObserver,
  },
  computed: {
    ...mapState('Auth', {
      loginDetails: 'loginDetails',
      activeRoleKey: 'activeRoleKey',
    }),
  },
})
export default class AdminLoginSecurityCode extends Vue {
  @Ref() readonly authSecurityCode!: { focusCodeInput: () => void };

  loginDetails!: {
    email: string;
    totp: string;
  };

  activeRoleKey!: string;

  errors = {};

  isLoading = false;

  handleLogin() {
    if (this.loginDetails.totp.length != 4) {
      this.errors = [{ security_code: 'Invalid Code' }];
      return;
    }
    this.isLoading = true;
    this.$store.dispatch('Auth/adminAttemptLogin').then((response) => {
      if (response.status) {
        this.$router.push({ name: 'administrator-dashboard' });
      } else {
        this.isLoading = false;
        this.errors = response.message;
      }
    });
  }

  handleResendEmail() {
    this.loginDetails.totp = '';
    this.authSecurityCode.focusCodeInput();
    return this.$store.dispatch('Auth/adminAttemptLogin');
  }
}
